import { EventEmitter } from "events";
import Dispatcher from "../Dispatcher";
import actionTypes from "../actions/ActionTypes";
const CHANGE_EVENT = "credentialChange";
let _allCredentials = [];
let _currentCredential = void 0;
let _lastChange = "";
let _lastError = "";
class CredentialStore extends EventEmitter {
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  getCredentials() {
    return _allCredentials;
  }
  getCurrentCredential() {
    return _currentCredential;
  }
  lastChange() {
    return _lastChange;
  }
  getLastError() {
    return _lastError;
  }
}
const store = new CredentialStore();
Dispatcher.register((action) => {
  _lastChange = action.actionType;
  switch (action.actionType) {
    case actionTypes.CredentialList:
      _lastChange = actionTypes.CredentialList;
      _allCredentials = action.Result;
      store.emitChange();
      break;
    case actionTypes.GetCredential:
      _lastChange = actionTypes.GetCredential;
      _currentCredential = action.Result;
      store.emitChange();
      break;
    case actionTypes.CredentialUpdate:
      _lastChange = actionTypes.CredentialUpdate;
      console.log("update cred");
      console.log(action.Result);
      if (action.Result.status === "Success") {
        _lastError = "";
        _currentCredential = action.Result.data;
      } else {
        _lastError = action.Result.updateMessage;
      }
      store.emitChange();
      break;
    case actionTypes.CredentialCreate:
      _lastChange = actionTypes.CredentialCreate;
      console.log("create cred");
      console.log(action.Result);
      if (action.Result.status === "Success") {
        _lastError = "";
        _currentCredential = action.Result.data;
      } else {
        _lastError = action.Result.updateMessage;
      }
      store.emitChange();
      break;
    case actionTypes.CredentialDelete:
      _lastChange = actionTypes.CredentialDelete;
      if (action.Result.updateStatus === "Success") {
        _lastError = "";
        _currentCredential = action.Result.result;
      } else {
        _lastError = action.Result.errorMessage;
      }
      store.emitChange();
      break;
    default:
  }
});
export default store;
